import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import "./hm-theme.css";

const FamilyAppointmentCancel = ({ isOpen, onRequestClose, appointment }) => {
  const [refundAmount, setRefundAmount] = useState(null);
  const [razorpayPaymentId, setRazorpayPaymentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isFamily = appointment?.familyid;
  const title = isFamily ? "Cancel Family Appointment" : "Cancel Employee Appointment";

  useEffect(() => {
    if (appointment && appointment.paymentId) {
      fetchPaymentData(appointment.paymentId);
    }
  }, [appointment]);

  const cancelAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoading(true);
    try {
      await axios.post("/api/employeeappointment/update", {
        id: `${appointmentId}`,
        appointmentstatus: "APPOINTMENT CANCELLED",
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Appointment cancelled successfully.");
      onRequestClose();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const fetchPaymentData = async (paymentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoading(true);
    try {
      const response = await axios.get(`/api/user/userpayment/getById/${paymentId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const refund = response.data.platformFee !== null
        ? (response.data.paymentAmount - response.data.platformFee).toFixed(2)
        : response.data.paymentAmount.toFixed(2);
      setRefundAmount(parseFloat(refund));
      setRazorpayPaymentId(response.data.razorpay_payment_id);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handleConfirmCancel = async () => {
    if (refundAmount !== null) {
      await handleRefund();
    } else {
      cancelAppointment(appointment.id);
    }
  };

  const handleRefund = async () => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoading(true);
    try {
      const response = await axios.post('/api/employeeappointment/cancel-and-refund', {
        appointmentId: appointment.id,
        razorpayPaymentId: razorpayPaymentId,
        refundAmount: refundAmount
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(response.data);
      onRequestClose();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.response?.data || error.message || "An error occurred.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">cancel</i>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}

        <div className="mb-3 p-3 rounded-3 d-flex align-items-start gap-3" style={{ background: "rgba(220,53,69,0.06)", border: "1px solid rgba(220,53,69,0.2)" }}>
          <i className="material-icons text-danger mt-1" style={{ fontSize: "1.4rem" }}>warning_amber</i>
          <div>
            <p className="fw-semibold mb-1">Cancel This Appointment?</p>
            <p className="text-muted small mb-0">This action cannot be undone. {appointment?.paymentId ? "A refund will be initiated." : ""}</p>
          </div>
        </div>

        {appointment?.paymentId && refundAmount !== null && (
          <div className="mb-4">
            <label className="form-label small fw-semibold">Refund Amount</label>
            <div className="input-group">
              <span className="input-group-text" style={{ background: "#f1f5f9" }}>₹</span>
              <input
                className="form-control fw-bold"
                type="text"
                value={refundAmount}
                readOnly
                style={{ fontWeight: "700", fontSize: "1.1rem", color: "#2f3a88" }}
              />
            </div>
            <span className="text-muted small">Full refund. Amount credited within 5–7 business days.</span>
          </div>
        )}

        <div className="d-flex justify-content-end gap-2">
          <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
            Keep Appointment
          </Button>
          <button
            className="btn btn-danger rounded-pill px-4 d-flex align-items-center gap-1"
            onClick={handleConfirmCancel}
            disabled={loading}
          >
            <i className="material-icons" style={{ fontSize: "1rem" }}>cancel</i>
            {appointment?.paymentId ? "Cancel & Refund" : "Confirm Cancellation"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FamilyAppointmentCancel;
